import { Button, DatePicker, Form } from "antd";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import React from "react";
import { EyeSVGIcon } from "pages/Login/Login.config";
const { INPUT } = FIELD_TYPE;
import dayjs from "dayjs";
import { formatToCurrencyType } from "helper/common";
import moment from "moment";

const validatePositiveInteger = (_, value) => {
  if (!value || /^[1-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};

const columns: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    render: (v, r, i) => i + 1,
    width: 30,
  },
  {
    key: 1,
    dataIndex: "maDichVu",
    title: "Mã dịch vụ",
    align: "center",
    selected: true,
    width: 50,
  },
  {
    key: 2,
    dataIndex: "tenChiDinh",
    title: "Tên dịch vụ",
    align: "left",
    editable: true,
    width: 200,
  },
  {
    key: 3,
    title: "Đơn giá",
    dataIndex: "donGia",
    selected: true,
    width: 50,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    
    },
    align:'right'
  },
  {
    key: 3,
    title: "Đơn giá BHYT",
    dataIndex: "baoHiemTra",
    selected: true,
    width: 80,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
    align:'right'
  },
  {
    key: 4,
    title: "Ngày chỉ định",
    dataIndex: "thoiGian",
    editable: true,
    type: "INPUT",
    width: 80,
    render: (t, r, i) => (
      <div>{t ? moment.utc(t).format(FORMAT_TIME.dateTime) : ""}</div>
    ),
    align: "center",
  },
  {
    key: 5,
    title: "Trạng thái TT",
    dataIndex: "trangThaiThanhToan",
    disabled: true,
    type: "INPUT",
    width: 100,
    render: (t) => {
      let value = "";
      if (t === 0) {
        return (value = "Chưa thanh toán");
      } else if (t === 1) {
        return (value = "Đã thanh toán");
      } else return (value = "--");
    },
  },
  {
    key: 6,
    title: "Trạng thái HĐ",
    dataIndex: "trangThai",
    disabled: true,
    type: "INPUT",
    width: 100,
  },
  {
    key: 7,
    title: "Ghi chú",
    dataIndex: "ghiChu",
    editable: true,
    type: "AUTO_COMPLETE",
    width: 200,
  },
];

export { columns };
